import { FunctionComponent, useEffect } from "react";
import deletemodelpopup from "../../assets/popup/deletemodelpopup.svg";
import deletemodelAnimatedicon from "../../assets/popup/meeting-delete-img.gif";
import { useForm } from "react-hook-form";

interface NotifyProps {
    showMessage?: any;
    onsubmit?: any;
    back?: any;
    notDelete?: boolean;
    removeExtraCSS?: boolean;
    msgHeading?: string;
    displayRubyRequired?: boolean;
    scrollablePop?: boolean;
    isDelete?: any;
}

const NotifyPopup: FunctionComponent<NotifyProps> = ({
    onsubmit,
    back,
    showMessage,
    notDelete,
    removeExtraCSS,
    msgHeading,
    displayRubyRequired,
    scrollablePop,
    isDelete,
}) => {
    const { handleSubmit } = useForm<any>({
        // resolver: yupResolver(),
    });
    useEffect(() => {
        document.body.classList.add("coverflow_hidden_scoll_bdy");

        return () => {
            document.body.classList.remove("coverflow_hidden_scoll_bdy");
        };
    }, []);
    return (
        <section id="model-main-blg">
            <div id="inner_loader_dv">
                <div className=" w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 viewinterction_cts-width">
                    <form
                        onSubmit={handleSubmit(onsubmit)}
                        className={`m-0 flex-1 rounded-radius-radius-lg bg-surface-bg-blue border-[1px] border-solid border-surface-border flex flex-col items-center justify-start ${removeExtraCSS === true ? "" : "p-8"
                            } mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border`}
                    >
                        <div className="p-0 mq575:p-0 min-w-full relative grid gap-[16px]">
                            <b>{msgHeading}</b>
                            <img
                                src={deletemodelpopup}
                                alt=""
                                className="cursor-pointer pr-0  mq575:pr-0 mq575:pt-0 w-5 h-5 absolute right-0 top-[-5px]  mq575:top-0 mq575:w-3 mq575:h-3 dark-white-img "
                                style={{}}
                                onClick={() => back(false)}
                            />
                            <div
                                className={`grid justify-between items-center ${scrollablePop === true ? "model_content-cts-h" : ""
                                    } relative`}
                            >
                                <span
                                    className="flex justify-between items-center gap-[0px]"
                                    style={displayRubyRequired ? { display: "ruby" } : {}}
                                >
                                    {notDelete ? (
                                        <></>
                                    ) : (
                                        <img
                                            src={deletemodelAnimatedicon}
                                            className="w-8 h-8 mq575:w-6 mq575:h-6 relative left-[-2px]"
                                            alt=""
                                        />
                                    )}
                                    <span className="text-xl font-bold min-w-full text-black dark:text-white modelpopup-blg-content-dv">
                                        {showMessage ? showMessage : "Do you want to delete this?"}
                                    </span>
                                </span>
                  
                            </div>
              
                            <div
                                className={` grid gap-[16px] mq575:gap-[16px] ${removeExtraCSS === true ? "pl-5 pb-5 pr-5" : ""
                                    } `}
                            >


                                <div
                                    className={`self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border min-w-full ${removeExtraCSS === true ? "flex justify-end" : ""
                                        } `}
                                >
                                    <button
                                        onClick={() => back(false)}
                                        type="button"
                                        className="cursor-pointer py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-white bg-surface-bg-primary rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] min-w-[88px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                                    >
                                        <div className="relative text-sm font-body-xs-semi-bold text-surface-primary-surface text-center inline-block min-w-[46px]">
                                            No
                                        </div>
                                    </button>
                                    <button
                                        type="submit"
                                        className={`cursor-pointer [border:none]  py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue ${isDelete == true ? "modeldelete_btn_dv" : ""
                                            } `}
                                    >
                                        <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block min-w-[32px]">
                                            Yes
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};
export default NotifyPopup;
